import { Toaster as SonnerToaster, toast as sonnerToast } from 'sonner'
import type * as React from 'react'

export interface ToasterProps {
  position?:
    | 'top-left'
    | 'top-center'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-center'
    | 'bottom-right'
  richColors?: boolean
  closeButton?: boolean
  duration?: number
}

/**
 * Toast provider baseado em sonner.
 * Deve ser montado uma única vez na raiz do app (ex: em App.tsx ou main.tsx).
 * Dispare toasts em qualquer lugar via `toast(...)` do atom.
 */
export const Toaster: React.FC<ToasterProps> = ({
  position = 'bottom-right',
  richColors = true,
  closeButton = true,
  duration = 4000,
}) => (
  <SonnerToaster
    position={position}
    richColors={richColors}
    closeButton={closeButton}
    duration={duration}
    theme="system"
    toastOptions={{
      classNames: {
        toast: 'rounded-lg shadow-md',
      },
    }}
  />
)

Toaster.displayName = 'Toaster'

/**
 * API unificada para disparar toasts.
 *
 * @example
 * toast.success('Salvo com sucesso')
 * toast.error('Falha ao conectar')
 * toast.warning('Verifique os dados')
 * toast.info('Processando...')
 * toast.promise(fetch('/api'), { loading: 'Enviando...', success: 'OK', error: 'Falhou' })
 */
export const toast = sonnerToast
